import PropTypes from 'prop-types';
import React from 'react';

import CommonStyles from '../Styles.module.scss';
import styles from './view.module.scss';
import cx from 'classnames';
import _ from 'lodash';
import { Row, Col, Image } from 'react-bootstrap';
import InputField from 'src/legacy/components/InputField';
import Button from 'src/components/button/index';

import ResetPasswordPage from './ResetPasswordPage.jsx';
import EmailSignatureContainer from './signature';
import DefaultUserProfileImage from 'src/legacy/images/default_user_profile_background.png';
import AssetIconEditor from 'src/legacy/components/AssetIconEditor';

import { toast } from 'react-toastify';

import userRoleService from "src/services/userRoles.service.js";
import { localizedStrings } from 'src/localization/index.jsx';
import DOMPurify from "dompurify";
import Toast from 'src/components/toast';

class ProfileView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this._handleChange = this._handleChange.bind(this);
    this.onUpdateProfile = this.onUpdateProfile.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
    this.onUploadClick = this.onUploadClick.bind(this);
    this._handleUpload = this._handleUpload.bind(this);
    this.onUploadCancel = this.onUploadCancel.bind(this);

    this.state = {
      firstName: this.props.user.firstName,
      lastName: this.props.user.lastName,
      title: this.props.user.title,
      phoneWork: this.props.user.workPhone || '',
      mobile: this.props.user.mobilePhone || '',
      errors: {},
      successMessage: 'none',
      icon: null,
      file: null
    } 

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedProfile = this.localizatedSettings.profile;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.updatingProfileSuccess !== this.props.updatingProfileSuccess && this.props.updatingProfileSuccess) {
      this.onResetClick(); 
      this.setState({ successMessage: 'inline-block' });

      setTimeout(() => {
          this.setState({ successMessage: 'none' });
      }, 2000);
    }
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value
    });
  }

  _handleUpload(e) {
    var file = e.target.files[0]
    var size = (file.size) / 1000;
    if (size < 2000) {
      this.setState({
        file: e.target.files[0]
      })
    }
    else {
      toast(
        <Toast.Failure
          className={styles.failureToast}
          message={this.localizedProfile.toast.failure.description}
        />,
        {
          position: "bottom-right",
          onClose: this.dismissErrorMessage,
          autoClose: 3000,
        },
      );
    }
  }

  validateForm(){
    let errors = {};
    const { firstName, title, email } = this.state;
    if(!firstName || firstName.trim() == ''){
        errors.firstName = this.localizedProfile.form.error_messages.valid_name;
    }

    return errors;
  }

  hasFieldError(field){
    return this.state.errors[field];
  }

  onUpdateProfile() {
    const errors = this.validateForm();
    if(Object.keys(errors).length != 0){
        this.setState({
        errors: errors
    });
        return;
    }

    var icon = this.state.icon;

    let request = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      title: this.state.title,
      email: this.props.user.email,
      workPhone: this.state.phoneWork,
      mobilePhone: this.state.mobile,
      icon: icon
    }
    
    this.props.updateUserProfile(request);
    this.setState({ errors: {}, successMessage: 'none' });
  }

  onUploadClick = (icon) =>  {
    this.setState({
      icon: icon,
      file: null
    });
  }

  onUploadCancel = () => {
    this.setState({
      icon: this.state.icon,
      file: null
    });
  }

  onResetClick() {
    this.setState({
      firstName: this.props.user.firstName || '',
      lastName: this.props.user.lastName || '',
      title: this.props.user.title || '',
      email: this.props.user.email || '',
      phoneWork: this.props.user.workPhone || '',
      mobile: this.props.user.mobilePhone || '',
      errors: {},
      successMessage: 'none',
      icon: null
    })
  }

  componentDidMount() {
  }

  render() {
    return (    
      <div className={ cx(CommonStyles.rightContent, styles.content)}>
        <div className={ styles.body }>
          <div className={styles.profile}>
            <div className={ CommonStyles.success } style={{display : this.state.successMessage}}>
                {this.localizedProfile.toast.success}
            </div>

            <div className={styles.top}>
                <div className={styles.iconContainer}>
                    {<Image src={ this.renderUserIcon()} key="icon" className={styles.imageStyle}/>}

                <div className={styles.uploadIconRow}>
                <span className={styles.editContent}>
                  <i className={cx("paperflite-edit", styles.editIcon)}></i>
                  <br />
                  <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.localizedProfile.form.edit_profile)}}></span>
                </span>
                <input
                  type="file"
                  className="file-input-hidden"
                  id="uploadStreamIcon"
                  accept="image/*"
                  onChange={this._handleUpload}
                  onClick={(e) => (e.target.value = "")}
                ></input>
                 </div>
              </div>
            </div>

            <Row className={ styles.row }>
              <Col sm={6} className={CommonStyles.column}>
                <InputField
                    className={ styles.inputField }
                    title={`${this.localizedProfile.form.first_name}:`}
                    placeholder=""
                    value={ this.state.firstName }
                    type="text"
                    focus={true}
                    reference="focusOn"
                    onChange={this._handleChange.bind(this, 'firstName')}
                    errorMessage={this.hasFieldError('firstName')}
                />
              </Col>
              <Col sm={6} className={CommonStyles.column}>
                <InputField
                    className={ styles.inputField }
                    title={`${this.localizedProfile.form.last_name}:`}
                    placeholder=""
                    value={ this.state.lastName }
                    type="text"
                    onChange={this._handleChange.bind(this, 'lastName')}
                />
              </Col>
            </Row>

            <Row className={ styles.row }>
              <InputField
                  className={ styles.inputField }
                  title={`${this.localizedProfile.form.title}:`}
                  placeholder=""
                  value={ this.state.title }
                  type="text"
                  spellCheck = {true}
                  onChange={this._handleChange.bind(this, 'title')}
                  errorMessage={this.hasFieldError('title')}
              />
            </Row>

            <Row className={ styles.row }>
              <InputField
                  className={ styles.inputField }
                  title={`${this.localizedProfile.form.email}:`}
                  placeholder=""
                  value={ this.props.user.email }
                  disabled={true}
                  type="text"
                  onChange={this._handleChange.bind(this, 'email')}
                    errorMessage={this.hasFieldError('email')}
              />
            </Row>

            <Row className={ styles.row }>
              <Col sm={6} className={CommonStyles.column}>
                <InputField
                  className={ styles.inputField }
                  title={`${this.localizedProfile.form.work_phone}:`}
                  placeholder=""
                  value={ this.state.phoneWork }
                  onChange={this._handleChange.bind(this, 'phoneWork')}
                />
              </Col>
              <Col sm={6} className={CommonStyles.column}>
                <InputField
                  className={ styles.inputField }
                  title={`${this.localizedProfile.form.mobile}:`}
                  placeholder=""
                  value={ this.state.mobile }
                  onChange={this._handleChange.bind(this, 'mobile')}
              />
              </Col>
            </Row>

            <div className={ styles.buttonTray }>
              <Button
                variant='primary'
                text={this.props.updatingProfile ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save}
                disabled={this.props.updatingProfile}
                className={styles.confirm}
                onClick={this.onUpdateProfile}
                icon='paperflite-tick'
              >
              </Button>
              <Button
                variant='secondary'
                text={this.localizedCommonActions.cancel}
                className={styles.cancel} 
                onClick={this.onResetClick}>
              </Button> 
            </div>
          </div>
          {(!this.props.account.ssoLoginMandatory || this.props.user.overrideSSOConfiguration) &&
            <ResetPasswordPage store={this.context.store}/> 
          }

          {
          // userRoleService.canShare() && 
            <EmailSignatureContainer />
          }       
        </div>
        {this.state.file &&
          <AssetIconEditor
            crop={{
              x: 0,
              y: 0,
              width: 100,
              height: 100,
              unit: "%",
              aspect: 1
            }}
            cropType='circle'
            show={this.state.file != null}
            image={this.state.file}
            collectioName = {_.get(this.state, "name", '')}
            onChange={this.onUploadClick}
            onCancel={this.onUploadCancel}
          />
        }
      </div>
    )
  }

  renderUserIcon(){
    if(this.state.icon){
      return this.state.icon;
    }else if(this.props.user.icon){
      return this.props.user.icon.full;
    }else{
      return DefaultUserProfileImage;
    }
  }
}

ProfileView.contextTypes = {
  store: PropTypes.object
}

export default  ProfileView;